<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
    <p>{{data.content}}</p>
</div>
<div class="pull-right" mat-dialog-actions *ngIf="data.modalType === 'confirm'">
  <button mat-raised-button (click)="modalEvent('cancel')">Cancel</button>
  <button mat-raised-button (click)="modalEvent('confirm')" cdkFocusInitial>Ok</button>
</div>